import { render, staticRenderFns } from "./SolicitorTable.vue?vue&type=template&id=077e1472"
import script from "./SolicitorTable.vue?vue&type=script&lang=js"
export * from "./SolicitorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports